export const slick_settings = {
  dots: true,
  slidesToShow: 1,
  centerMode: true,
  centerPadding: '30px',
  speed: 300,
  // centerPadding: '10px',
  // centerMode: true,
  // variableWidth: true,
}